export default {
    iKnow: 'Got it',
    yzmfssb: 'Verification code send failed',

    oldEmail: {
        desc1: 'Current email is used for password recovery,',
        desc2: 'Update if it’s no longer valid',
        change: 'Change verified email',
    },

    captcha: {
        inputEmailCode: 'Enter email code',
        sentEmailTo: 'Code sent to:',
        resend: 'Resend',
        notReceive: 'No code received',
        connectUs: 'Contact us',
        dlkf: 'Mainland support:',
        xgkf: 'HK support:',
        wrongCaptcha: 'Invalid or expired code, please re-enter',
        repeatTips: 'No need to resend within 60s',
        wrongEmail: 'Email verification failed or expired, please re-enter',
        wrongTooMuch: 'Too many attempts, try later',
    },

    newEmail: {
        changeEmail: 'Set new verified email',
        desc: 'After change, you can use new email for password recovery',
        inputEmail: 'Enter email address',
        sendCode: 'Send confirmation email',
        syncAccountEmail: 'Sync securities account email',
        syncAccountEmailTitle: 'Sync securities account info',
        info1: 'You’re updating platform email, mainly for login and password recovery. Securities account email will be synced.',
        info2: 'Contact support if you need different emails for Star Wealth and securities account.',
        dlkf: 'Mainland support:',
        xgkf: 'HK support:',
        inputCorrectEmail: 'Enter valid email address',
        notSameEmail: 'New email cannot be the same as current',
    },

    identity: {
        title: 'Identity Verification',
        desc: 'Enter account opening ID for verification, case-insensitive, no brackets',
        idNumber: 'Account opening ID',
        nextStep: 'Next',
        desc1: 'Account opening ID is case-insensitive. No brackets for HK ID.',
        desc2: 'Examples:',
        example1: 'HK ID: G1234567',
        example2: 'Mainland ID: 12345678901234567X',
        example3: 'Mainland passport: E12345678',
        wrongIdNumber: 'Identity verification failed, please re-enter',
    },

    result: {
        success: 'Change successful',
        desc: 'Verified email updated successfully',
        finish: 'Done',
    },
}
